import React from 'react';

const AdminPopup = ({
  open,
  closePopup = () => {},
  title,
  subTitle,
  children,
  footer,
  customHeightClasses,
  customWidthClasses,
  backButton,
  variant = 'default',
}) => {
  if (!open) return null;

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center ${
        variant === 'delete' ? 'bg-black/70 p-4' : 'bg-white/10 backdrop-blur-sm'
      }`}>
      <div className="absolute top-0 left-0 w-full h-full z-10" onClick={closePopup} />
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        className={`bg-white shadow-md flex flex-col w-full ${customWidthClasses || 'max-w-2xl'} ${customHeightClasses || 'h-[80vh] max-h-[900px]'} ${variant === 'teal' ? 'border border-teal-10' : ''} ${variant === 'delete' ? 'rounded-[20px] max-h-[calc(100vh-2rem)]' : 'rounded-lg'} relative z-20 overflow-hidden`}>
        {/* Header */}
        {variant === 'delete' ? (
          <div className="flex h-[70px] shrink-0 items-center bg-teal-40 px-5 sm:px-10">
            <button
              type="button"
              onClick={closePopup}
              disabled={!closePopup}
              aria-label="Retour"
              className="flex h-8 w-8 items-center justify-center rounded-md bg-white text-teal-40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-10 disabled:opacity-50">
              <svg
                className="h-5 w-5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="m15 18-6-6 6-6" />
              </svg>
            </button>
          </div>
        ) : (
          title && (
            <div
              className={`${variant === 'teal' ? 'bg-gradient-to-r from-teal-10 to-white' : 'bg-lightBlue-10'} text-blue-10 px-4 py-2 flex justify-between items-center`}>
              <div className="flex items-center">
                {backButton && backButton.show && (
                  <button
                    onClick={backButton.onClick}
                    className="mr-4 bg-blue-10 text-white w-6 h-6 flex items-center justify-center rounded-lg shadow-sm hover:bg-blue-20 hover:scale-105 active:scale-95 transition-all duration-300">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round">
                      <polyline points="15 18 9 12 15 6"></polyline>
                    </svg>
                  </button>
                )}
                <div className="flex flex-col">
                  <h2 className="font-semibold">{title}</h2>
                  {subTitle && <h2 className="text-sm">{subTitle}</h2>}
                </div>
              </div>
              <button
                onClick={closePopup}
                className="bg-blue-10 text-white w-6 h-6 flex items-center justify-center rounded-lg shadow-sm hover:bg-blue-20 hover:scale-105 active:scale-95 transition-all duration-300">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          )
        )}

        {/* Content - Scrollable */}
        <div
          className={
            variant === 'delete' ? 'flex-grow overflow-y-auto' : 'flex-grow overflow-y-auto p-4'
          }>
          {children}
        </div>

        {/* Footer - Fixed at the bottom */}
        {footer && <div className="border-t border-gray-200 p-4 bg-white">{footer}</div>}
      </div>
    </div>
  );
};

export default AdminPopup;
